export default __webpack_public_path__ + "static/66-2df7e66f6b312741fe598f5103fb314d.png";